module.exports = __webpack_public_path__ + "static/media/gold.1b383454.png";